import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AUTHOR_EMAIL, AUTHOR_NAME } from "../lib/site";

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-display text-xl font-semibold text-choc">{title}</h2>
    <div className="mt-3 space-y-3">{children}</div>
  </section>
);

export const LegalLayout = ({ title, testid, updated, children }) => (
  <div data-testid={testid} className="min-h-screen bg-cream px-6 py-16 sm:px-10 sm:py-20">
    <div className="mx-auto max-w-3xl">
      <Link
        data-testid={`${testid}-back-link`}
        to="/"
        className="inline-flex items-center gap-2 text-sm font-semibold text-brick transition-colors duration-300 hover:text-brick-dark"
      >
        <ArrowLeft className="h-4 w-4" />
        Wróć na stronę główną
      </Link>
      <h1 className="mt-8 font-display text-3xl font-semibold tracking-tight text-choc sm:text-4xl">
        {title}
      </h1>
      <p className="mt-3 text-xs uppercase tracking-wider text-clay">
        Ostatnia aktualizacja: {updated}
      </p>
      <div className="mt-10 space-y-9 text-sm leading-relaxed text-clay sm:text-base">
        {children}
      </div>
      <p className="mt-14 border-t border-sand pt-6 text-xs text-clay/70">
        {AUTHOR_NAME} · prawodorzeczy.pl · {AUTHOR_EMAIL}
      </p>
    </div>
  </div>
);
